var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-form-item",
      class: { "v-form-item--inline": _vm.isInline },
    },
    [
      !_vm.isNoLabel
        ? _c(
            "label",
            {
              ref: "label",
              staticClass: "v-form-item__label",
              class: [
                _vm.sizeCss,
                {
                  "v-form-item__label--right": _vm.labelPosition === "right",
                },
              ],
              style: { width: _vm.labelWidth + "px" },
            },
            [
              _vm.label
                ? _c("span", { ref: "labelTxt" }, [_vm._v(_vm._s(_vm.label))])
                : _c(
                    "span",
                    { ref: "labelTxt", class: _vm.sizeCss },
                    [_vm._t("label")],
                    2
                  ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "v-form-item__content",
          class: {
            "v-form-item__content--no-label": _vm.isNoLabel,
            [_vm.sizeCss]: _vm.sizeCss,
          },
          style: {
            "margin-left": !_vm.isNoLabel ? _vm.labelWidth + 20 + "px" : "0",
          },
        },
        [
          _vm._t("default"),
          _c("div", { style: { height: _vm.errHeight } }, [
            _vm.showError
              ? _c(
                  "div",
                  {
                    ref: "error",
                    staticClass: "v-form-item__content__msg is-error",
                  },
                  [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]
                )
              : _vm._e(),
          ]),
          _vm._t("content"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }